import React from 'react'

import './ModalOrder.scss'

export const ModalOrder =({show, close}) =>{
    return(
        <div className="modal-wrapper" 
        style={{
            transform:show ? 'translateY(0vh)':'translateY(-100vh)',
            opacity:show ? '1' : '0'}}>
           <div className="modal-content">
               <h4>Wichtiger Hinweis:</h4>
               <p>Gutscheine und Gutscheine von Berufsgenossenschaften können im Onlineshop nicht eingelöst werden. <br/>
                   Bitte rufen Sie uns an oder schicken uns eine Mail um welchen Gutschein es sich handelt. <br/>
                   Vielen Dank, Ihr Team.
               </p>
           </div>
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/components/ModalOrder.jsx